// src/pages/CreateCampaign.jsx
//
// Poora "Create Campaign" form. Tumhare CRM ke folder structure ke
// hisaab se import path adjust kar lena (jis folder mein tum ise
// rakhoge, waha se "../services/campaignService" sahi hona chahiye).

import { useState, useEffect } from "react";
import {
  previewNextCampaignId,
  
  createCampaign,
  
} from "./campaignService.js"

export default function CreateCampaign() {
  const [campaignId, setCampaignId] = useState("Generating...");
  const [saving, setSaving] = useState(false);
  const [couponAvailable, setCouponAvailable] = useState(null);

  const [form, setForm] = useState({
    type: "coupon_discount",
    name: "",
    description: "",
    eligibility: {
      applyMethod: "customer_code",
      supportCanApply: true,
      couponCode: "",
      eligibleProduct: "cow_milk",
      minSubscriptionDurationDays: 90,
      discountType: "percentage",
      discountAmount: "",
      customerType: "all",
      acquisitionSource: "",
    },
    validity: {
      startDate: "",
      endDate: "",
      maxUsagePerCustomer: 1,
    },
  });

  // Campaign type badalte hi us type ki agli ID ka PREVIEW dikhao
  // (asli ID save ke waqt milti hai)
  useEffect(() => {
    previewNextCampaignId(form.type)
      .then(setCampaignId)
      .catch((err) => {
        console.error(err);
        setCampaignId("");
      });
  }, [form.type]);

  // Coupon code type karte waqt availability check (500ms debounce)
//   useEffect(() => {
//     const code = form.eligibility.couponCode;
//     if (!code) {
//       setCouponAvailable(null);
//       return;
//     }
//     const timer = setTimeout(async () => {
//       try {
//         const available = await checkCouponAvailability(code);
//         setCouponAvailable(available);
//       } catch (err) {
//         console.error(err);
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [form.eligibility.couponCode]);

  const updateField = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const updateEligibility = (key, value) =>
    setForm((prev) => ({
      ...prev,
      eligibility: { ...prev.eligibility, [key]: value },
    }));

  const updateValidity = (key, value) =>
    setForm((prev) => ({
      ...prev,
      validity: { ...prev.validity, [key]: value },
    }));

  const handleSave = async (activateNow) => {
    if (!form.name || (form.type === "coupon_discount" && !form.eligibility.couponCode)) {
      alert("Coupon name aur code dena zaroori hai.");
      return;
    }
    if (couponAvailable === false) {
      alert("Ye coupon code already use ho raha hai, dusra try karo.");
      return;
    }

    setSaving(true);
    try {
      const payload = { campaignId, ...form, activateNow };
      const result = await createCampaign(payload);
      alert(`Campaign saved successfully! ID: ${result.campaignId}`);
    } catch (err) {
      console.error(err);
      alert("Kuch galat ho gaya: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 24, fontFamily: "sans-serif" }}>
      <h1>Create Campaign</h1>

      {/* SECTION 1: Campaign type */}
      <section style={sectionStyle}>
        <h3>1 · Campaign type</h3>
        <div style={{ display: "flex", gap: 12 }}>
          {[
            { key: "coupon_discount", label: "Coupon / Discount" },
            { key: "offer", label: "Offer" },
            { key: "wallet_cashback", label: "Wallet Cashback" },
            { key: "refer_earn", label: "Refer & Earn" },
          ].map((opt) => (
            <button
              key={opt.key}
              onClick={() => updateField("type", opt.key)}
              style={{
                padding: 12,
                flex: 1,
                border: form.type === opt.key ? "2px solid #2e6b3e" : "1px solid #ccc",
                background: form.type === opt.key ? "#eaf3ec" : "#fff",
                borderRadius: 8,
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </section>

      {/* SECTION 2: Basics */}
      <section style={sectionStyle}>
        <h3>2 · Basics</h3>
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label>Coupon name</label>
            <input
              style={inputStyle}
              value={form.name}
              onChange={(e) => updateField("name", e.target.value)}
              placeholder="3-Month Cow Milk 10% Off"
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>Internal Campaign ID</label>
            <input style={inputStyle} value={campaignId} readOnly disabled />
            <small>Assigned automatically on save</small>
          </div>
        </div>
        <div style={{ marginTop: 12 }}>
          <label>Description</label>
          <textarea
            style={{ ...inputStyle, height: 60 }}
            value={form.description}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </div>
      </section>

      {/* SECTION 3: Eligibility & discount */}
      <section style={sectionStyle}>
        <h3>3 · Eligibility & discount</h3>

        <label>How is it applied?</label>
        <div style={{ display: "flex", gap: 16, margin: "8px 0" }}>
          <label>
            <input
              type="radio"
              checked={form.eligibility.applyMethod === "customer_code"}
              onChange={() => updateEligibility("applyMethod", "customer_code")}
            />{" "}
            Customer enters code
          </label>
          <label>
            <input
              type="radio"
              checked={form.eligibility.applyMethod === "auto_apply"}
              onChange={() => updateEligibility("applyMethod", "auto_apply")}
            />{" "}
            Auto-apply when eligible
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.eligibility.supportCanApply}
              onChange={(e) => updateEligibility("supportCanApply", e.target.checked)}
            />{" "}
            Support team can also apply it
          </label>
        </div>

        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label>Coupon code</label>
            <input
              style={inputStyle}
              value={form.eligibility.couponCode}
              onChange={(e) => updateEligibility("couponCode", e.target.value.toUpperCase())}
              placeholder="MILK3M10"
            />
            {couponAvailable === true && <small style={{ color: "green" }}>Available</small>}
            {couponAvailable === false && <small style={{ color: "red" }}>Already in use</small>}
          </div>

          <div style={{ flex: 1 }}>
            <label>Eligible product</label>
            <select
              style={inputStyle}
              value={form.eligibility.eligibleProduct}
              onChange={(e) => updateEligibility("eligibleProduct", e.target.value)}
            >
              <option value="cow_milk">Cow Milk</option>
              <option value="buffalo_milk">Buffalo Milk</option>
              <option value="curd">Curd</option>
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label>Minimum subscription duration</label>
            <select
              style={inputStyle}
              value={form.eligibility.minSubscriptionDurationDays}
              onChange={(e) =>
                updateEligibility("minSubscriptionDurationDays", Number(e.target.value))
              }
            >
              <option value={30}>1 month (30 days)</option>
              <option value={90}>3 months (90 days)</option>
              <option value={180}>6 months (180 days)</option>
            </select>
          </div>
        </div>

        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label>Discount type</label>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => updateEligibility("discountType", "fixed")}
                style={toggleBtn(form.eligibility.discountType === "fixed")}
              >
                Fixed ₹
              </button>
              <button
                onClick={() => updateEligibility("discountType", "percentage")}
                style={toggleBtn(form.eligibility.discountType === "percentage")}
              >
                Percentage %
              </button>
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <label>Discount amount</label>
            <input
              type="number"
              style={inputStyle}
              value={form.eligibility.discountAmount}
              onChange={(e) => updateEligibility("discountAmount", Number(e.target.value))}
              placeholder="10"
            />
          </div>

          <div style={{ flex: 1 }}>
            <label>Customer type</label>
            <div style={{ display: "flex", gap: 8 }}>
              {["new", "existing", "all"].map((t) => (
                <button
                  key={t}
                  onClick={() => updateEligibility("customerType", t)}
                  style={toggleBtn(form.eligibility.customerType === t)}
                >
                  {t.charAt(0).toUpperCase() + t.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: Validity & limits */}
      <section style={sectionStyle}>
        <h3>4 · Validity & limits</h3>
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label>Start date</label>
            <input
              type="date"
              style={inputStyle}
              value={form.validity.startDate}
              onChange={(e) => updateValidity("startDate", e.target.value)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>End date</label>
            <input
              type="date"
              style={inputStyle}
              value={form.validity.endDate}
              onChange={(e) => updateValidity("endDate", e.target.value)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>Maximum usage per customer</label>
            <select
              style={inputStyle}
              value={form.validity.maxUsagePerCustomer}
              onChange={(e) => updateValidity("maxUsagePerCustomer", Number(e.target.value))}
            >
              <option value={1}>1 time (recommended)</option>
              <option value={2}>2 times</option>
              <option value={0}>Unlimited</option>
            </select>
          </div>
        </div>
      </section>

      {/* ACTION BUTTONS */}
      <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
        <button disabled={saving} onClick={() => handleSave(true)} style={{ ...primaryBtn, flex: 1 }}>
          {saving ? "Saving..." : "Activate campaign"}
        </button>
        <button disabled={saving} onClick={() => handleSave(false)} style={{ ...secondaryBtn, flex: 1 }}>
          Save as inactive
        </button>
      </div>
    </div>
  );
}

const sectionStyle = { border: "1px solid #e2e2e2", borderRadius: 10, padding: 20, marginBottom: 20 };
const rowStyle = { display: "flex", gap: 16, marginTop: 12 };
const inputStyle = { width: "100%", padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6, marginTop: 4 };
const toggleBtn = (active) => ({
  flex: 1,
  padding: 8,
  border: active ? "1px solid #2e6b3e" : "1px solid #ccc",
  background: active ? "#2e6b3e" : "#fff",
  color: active ? "#fff" : "#000",
  borderRadius: 6,
  cursor: "pointer",
});
const primaryBtn = { background: "#2e6b3e", color: "#fff", padding: 14, border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
const secondaryBtn = { background: "#fff", color: "#2e6b3e", padding: 14, border: "1px solid #2e6b3e", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
